import {Injectable} from '@angular/core';
import {of} from 'rxjs';
import {CURRENCIES} from './static-data/currencies';

@Injectable({providedIn: 'root'})
export class CurrenciesService {
  constructor() {}

  getCurrencies() {
    return of(CURRENCIES);
  }
}
